import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useUserInfo } from '../../User'
import { numberFormat } from '../../utils'
import { SweepstakesEntryCount, useSweepstakesOptionsAmountPerEntry } from '../Sweepstakes'

const SweepstakesConfirmDetails = () => {
  const theme = useTheme()
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
  const amountPerEntry = useSweepstakesOptionsAmountPerEntry()
  const { userInfo } = useUserInfo()
  const [entryCount] = SweepstakesEntryCount.useContext()
  const totalAmount = amountPerEntry * entryCount

  return (
    <Box display="flex" flexGrow={1} sx={isMdUp ? { mx: 2 } : {}}>
      <Box flexGrow={1}>
        <Box>
          <Typography variant="caption">Balance</Typography>
        </Box>
        <Box>
          <Typography variant="caption">Amount</Typography>
        </Box>
      </Box>
      <Box textAlign="right">
        <Box>
          <Typography variant="caption" noWrap>
            <strong>{numberFormat(Math.max(0, userInfo?.xyoCollected ?? 0))} COIN</strong>
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" noWrap>
            <strong>- {numberFormat(totalAmount)} COIN</strong>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default SweepstakesConfirmDetails
